<div class="container">
  <p class="confirmation-text">
    The Shopconnect experience is better in the mobile app.
  </p>
  <div class="buttons">
    <button mat-button class="agree" (click)="onOpenApp.emit(true)">
      Continue in app
    </button>
    <button mat-button class="decline" (click)="onOpenApp.emit(false)">
      Continue in browser
    </button>
  </div>
</div>
